var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select-input',{staticClass:"active-loan-selector elevation-4",attrs:{"value":_vm.activeLoan,"items":_vm.availableLoans,"item-text":"label","item-value":"loan_number","hide-details":"","attach":".active-loan-selector","solo":"","flat":""},on:{"input":_vm.setActiveLoan}})
}
var staticRenderFns = []

export { render, staticRenderFns }